import React from "react";

interface Props {
  children: React.ReactNode;
}

export const UnorderedList: React.FC<Props> = ({ children }) => {
  return (
    <ul className="mb-300 list-disc space-y-100 pl-200 pr-300">{children}</ul>
  );
};
